import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { UseCase } from "../../base/use-case";
import { GetPlanJobsLocationsRequest, Location, PlanJobsLocationsListResponse } from "../../domain";
import { LocationsRepository } from "../../repositories";

@Injectable({ providedIn: 'root' })
export class GetPlanAndJobsLocationsUsecase implements UseCase<GetPlanJobsLocationsRequest, PlanJobsLocationsListResponse> {

  constructor(private locationRepository: LocationsRepository) {
  }

  execute(params: GetPlanJobsLocationsRequest): Observable<PlanJobsLocationsListResponse>{
    return this.locationRepository.GetPlanAndJobsLocations(params);
  }

}
